module.exports = __webpack_public_path__ + "static/img/solution-content4.c58a01c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution-content4.png
// module id = 4ekS
// module chunks = 0